import { Typography } from "@mui/material";
import { type FC, type MouseEvent, useCallback, useMemo } from "react";

import { useEventMarketsSettings } from "~/feature/event/providers/EventMarketsSettingsProvider";

import * as Styled from "./SwitchGrouping.styles";

export const SwitchGrouping: FC = () => {
  const { ungroup, setUngroup } = useEventMarketsSettings();

  const isUngrouped = ungroup;

  const text = useMemo(
    () => (isUngrouped ? "Ungrouped" : "Grouped"),
    [isUngrouped]
  );

  const handleToggle = useCallback(() => {
    setUngroup(!isUngrouped);
  }, [isUngrouped, setUngroup]);

  const stopEvent = useCallback((event: MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
  }, []);

  const handleRootClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      stopEvent(event);
      handleToggle();
    },
    [handleToggle, stopEvent]
  );

  const handleSwitchClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      stopEvent(event);
      handleToggle();
    },
    [handleToggle, stopEvent]
  );

  const handleMouseDown = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      stopEvent(event);
    },
    [stopEvent]
  );

  return (
    <Styled.Root
      onClick={handleRootClick}
      onMouseDown={handleMouseDown}
      disableRipple
    >
      <Styled.Switch
        checked={!isUngrouped}
        onClick={handleSwitchClick}
        onMouseDown={handleMouseDown}
      />
      <Typography
        variant="caption"
        sx={{
          fontSize: 13,
          fontWeight: 500
        }}>
        {text}
      </Typography>
    </Styled.Root>
  );
};
